<script setup lang="ts">
import type { LargeLinklistFieldsFragment } from '~/api/graphql/generated'

const props = defineProps<{
  entity: LargeLinklistFieldsFragment
}>()

type LargeLinklistFieldItem = NonNullable<NonNullable<LargeLinklistFieldsFragment['fieldItems']>[number]>
type LargeLinklistFieldEntity = LargeLinklistFieldItem['entity']
type LargeLinklistItemEntity = Extract<
  NonNullable<LargeLinklistFieldEntity>,
  { __typename?: 'ParagraphLargeLinklistItem' }
>

const getLargeLinklistItem = (
  entity: LargeLinklistFieldEntity | null | undefined,
): LargeLinklistItemEntity | undefined => (entity?.__typename === 'ParagraphLargeLinklistItem' ? entity : undefined)

const items = props.entity.fieldItems?.map((item) => {
  const entity = getLargeLinklistItem(item?.entity)
  return {
    title: entity?.fieldTitle || '',
    subtitle: entity?.fieldSubtitle || '',
    description: entity?.fieldDescription?.processed || '',
    link: {
      url: entity?.fieldLink?.url?.path || '',
      text: entity?.fieldLink?.title || '',
      target: entity?.fieldLink?.attribute || '',
    },
  }
})
</script>

<template>
  <SectionSpecial :title="entity?.fieldTitle || ''">
    <LinkListLarge>
      <template #default="{ isHovered }">
        <LinkListLargeItemEducationalOffering
          v-for="(item, j) of items"
          :key="j"
          v-animate="{ animation: 'vertical-reveal' }"
          :title="item.title"
          :subtitle="item.subtitle"
          :description="item.description"
          :link="item.link"
          :dim="isHovered"
        />
      </template>
    </LinkListLarge>
  </SectionSpecial>
</template>
